import {
  DRAFT_AI_GENERATIONS_API,
  forceLogout,
  getErrorMessage,
  jsonHeadersWithToken,
  parseJsonSafe,
} from '@/lib/constants'

const DEFAULT_LIMIT = 20
const DEFAULT_LOOKBACK_DAYS = 7

export async function getDraftGenerations({
  limit = DEFAULT_LIMIT,
  lookbackDays = DEFAULT_LOOKBACK_DAYS,
  mode = 'all',
} = {}) {
  const params = new URLSearchParams({
    limit: String(limit),
    lookbackDays: String(lookbackDays),
    mode,
  })

  const response = await fetch(
    `${DRAFT_AI_GENERATIONS_API}/guest/ai-draft-generations?${params.toString()}`,
    {
      method: 'GET',
      headers: jsonHeadersWithToken(),
    }
  )

  const data = await parseJsonSafe(response)

  if (!response.ok) {
    if (response.status === 401) {
      forceLogout()
      return new Promise(() => {})
    }

    throw new Error(
      getErrorMessage(data, 'Failed to fetch draft generations')
    )
  }

  return {
    ...data,
    data: {
      aiCompanion: Array.isArray(data?.data?.aiCompanion)
        ? data.data.aiCompanion
        : [],
      visualBuilder: Array.isArray(data?.data?.visualBuilder)
        ? data.data.visualBuilder
        : [],
    },
    counts: {
      aiCompanion: Number(data?.counts?.aiCompanion || 0),
      visualBuilder: Number(data?.counts?.visualBuilder || 0),
    },
  }
}
